import { ModalNavButtonType, ModalType } from 'src/types/Modal';

import { MobileModalNavButtonType } from '.';

type MultiStepModalTypes = ModalType.LOGIN | ModalType.MORE | ModalType.CREATOR_APPLY;

interface MultiStepModalNavButtonConfig {
  desktop: [ModalNavButtonType, ModalNavButtonType];
  mobile: [MobileModalNavButtonType, MobileModalNavButtonType];
}

const DEFAULT_MULTI_STEP_MODAL_NAV_BUTTON_CONFIG: MultiStepModalNavButtonConfig = {
  desktop: [ModalNavButtonType.CLOSE, ModalNavButtonType.BACK_AND_CLOSE],
  mobile: [ModalNavButtonType.CLOSE, ModalNavButtonType.BACK],
};

const CUSTOM_MULTI_STEP_MODAL_NAV_BUTTON_CONFIGS: Partial<
  Record<MultiStepModalTypes, MultiStepModalNavButtonConfig>
> = {
  [ModalType.MORE]: {
    desktop: [ModalNavButtonType.BACK, ModalNavButtonType.BACK],
    mobile: [ModalNavButtonType.CLOSE, ModalNavButtonType.BACK],
  },
};

export const getMultiStepModalNavButtonType = (
  modalType: MultiStepModalTypes,
  stepNumber: number
) => {
  const navButtonConfig =
    CUSTOM_MULTI_STEP_MODAL_NAV_BUTTON_CONFIGS[modalType] ??
    DEFAULT_MULTI_STEP_MODAL_NAV_BUTTON_CONFIG;

  const configIndex = stepNumber === 1 ? 0 : 1;

  return {
    desktopNavButtonType: navButtonConfig.desktop[configIndex],
    mobileNavButtonType: navButtonConfig.mobile[configIndex],
  } as const;
};
